import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    width: '100%',
    height: '100%',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
  },
  icon: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
}))

export default useStyles
